import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Cell, Pie, PieChart, Sector } from 'recharts';
import { getSpendingTrendsAnalyticsProps } from '../../../../const/analytics/spending-trends';
import useDeviceWidth from '../../../../hooks/use-device-width';
import ChartDetails from '../chart-details';
import { StyledWheelChart } from '../subcomponents';
var renderActiveShape = function (shapeProps) {
    var cx = shapeProps.cx, cy = shapeProps.cy, innerRadius = shapeProps.innerRadius, outerRadius = shapeProps.outerRadius, startAngle = shapeProps.startAngle, endAngle = shapeProps.endAngle, fill = shapeProps.fill;
    return (_jsxs("g", { children: [_jsx(Sector, { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle, fill: fill }), outerRadius && (_jsx(Sector, { cx: cx, cy: cy, startAngle: startAngle, endAngle: endAngle, cornerRadius: 8, innerRadius: outerRadius + 8, outerRadius: outerRadius + 13, fill: fill }))] }));
};
var WheelChart = function (_a) {
    var data = _a.data, totalAmount = _a.totalAmount, setSelectedCategory = _a.setSelectedCategory;
    var _b = useState(0), activeIndex = _b[0], setActiveIndex = _b[1];
    var _c = useState(), activeClickedIndex = _c[0], setActiveClickedIndex = _c[1];
    var analyticProps = getSpendingTrendsAnalyticsProps().chart;
    var isMobile = useDeviceWidth();
    useEffect(function () {
        data.forEach(function (item) {
            var _a;
            var element = (_a = document.querySelector("[name=\"".concat(item.name, "\"]"))) === null || _a === void 0 ? void 0 : _a.parentElement;
            if (element) {
                element === null || element === void 0 ? void 0 : element.setAttribute('data-type', item.name);
                element === null || element === void 0 ? void 0 : element.setAttribute('data-reason', '');
                element === null || element === void 0 ? void 0 : element.setAttribute('data-object', analyticProps['data-object']);
                element === null || element === void 0 ? void 0 : element.setAttribute('data-analytics', analyticProps['data-analytics']);
            }
        });
    }, [analyticProps, data]);
    var onPieEnter = function (_, index) {
        setActiveIndex(index);
        setSelectedCategory(data === null || data === void 0 ? void 0 : data[index].name);
    };
    var onPieClick = function (_, index) {
        // pie click functionality is only needed for mobile
        if (!isMobile)
            return;
        setActiveClickedIndex(index);
    };
    var onPieClickOutside = function () {
        setActiveClickedIndex(undefined);
    };
    var clickedIndexIsNotUndefined = activeClickedIndex !== undefined;
    var activeCategory = activeIndex !== undefined ? data[activeIndex] : undefined;
    var activeClickedCategory = clickedIndexIsNotUndefined
        ? data[activeClickedIndex]
        : undefined;
    var totalSpent = activeCategory
        ? data.reduce(function (acc, cur) { return acc + Number(cur.amount); }, 0)
        : totalAmount;
    return (_jsxs(StyledWheelChart, { children: [_jsx(PieChart, { width: 324, height: 324, style: { zIndex: 99 }, children: _jsx(Pie, { activeIndex: clickedIndexIsNotUndefined ? activeClickedIndex : activeIndex, activeShape: renderActiveShape, data: data, innerRadius: 104, outerRadius: 146, paddingAngle: 2, strokeWidth: 0, startAngle: -14, dataKey: "value", onMouseEnter: onPieEnter, onClick: onPieClick, onBlur: onPieClickOutside, children: data.map(function (entry) { return (_jsx(Cell, { fill: entry.color }, "cell-".concat(entry.name))); }) }) }), _jsx(ChartDetails, { activeCategory: activeClickedCategory || activeCategory, totalSpent: totalSpent })] }));
};
export default WheelChart;
//# sourceMappingURL=index.js.map